import { httpRequest } from "../../../utils/HttpRequest";
import {
    IKey,
    IMdCmFields,
    IPage,
    ISearchPageField
} from "../../../types/FmsTypes";
import { LONG_REQUEST_TIMEOUT } from "@/utils/constants";


export interface IMdAppFields extends IMdCmFields {
    code?: string;
    name?: string;
    note?: string;
    status?: number;
}

export type IMdApp = IKey & IMdCmFields & IMdAppFields;
export type IMdAppSearch = IMdAppFields & ISearchPageField;

class AppService {
    async insert(insertVo: IMdAppFields) {
        const appInsertUrl = "/app/insert";
        let ret = await httpRequest.post<IMdApp>(appInsertUrl, insertVo);
        return ret;
    }

    async disable(oneVo: IMdAppFields) {
        const appDisableUrl = "/app/disable";
        let ret = await httpRequest.post<boolean>(appDisableUrl, oneVo);
        return ret;
    }

    async find(searchVo: IMdAppFields) {
        const appPageUrl = "/app/find";
        return await httpRequest.post<IMdApp[]>(appPageUrl, searchVo);
    }

    async appDs(searchVo: IMdAppFields) {
        let { retData } = await this.find(searchVo);
        return retData.map(el => ({
            label: el.name ?? "",
            value: el.code ?? ""
        }))
    }

    async page(searchVo: IMdAppSearch) {
        const appPageUrl = "/app/page";
        return await httpRequest.post<IPage<IMdApp>>(appPageUrl, searchVo);
    }

    async one(oneVo: IMdAppFields) {
        const appDisableUrl = "/app/one";
        return await httpRequest.post<IMdApp>(appDisableUrl, oneVo);
    }

    async sync(syncVo: IMdAppFields) {
        const appPageUrl = "/app/sync";
        syncVo.branchList = ["main", "fms"];
        return await httpRequest.post<boolean>(appPageUrl, syncVo, { timeout: LONG_REQUEST_TIMEOUT });
    }

    async syncPage(searchVo: IMdAppSearch) {
        const appPageUrl = "/app/syncPage";
        searchVo.branchList = ["main", "fms"];
        return await httpRequest.post<boolean>(appPageUrl, searchVo);
    }

    async syncOne(oneVo: IMdAppFields) {
        const appPageUrl = "/app/syncPage";

        return await httpRequest.post<boolean>(appPageUrl, oneVo);
    }
}

export const appService = new AppService();
export default appService
